import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  getBrandPriceCode,
  getBrandStorePrice,
} from "../../../services/StorePriceCode/getPriceCode";
import StorePriceStatusChange from "./StorePriceStatusChange";
import StorePriceAddModal from "./StorePriceAddModal";
import AdminMenu from "../../AdminMenu";
import StoreConfigPriceDefault from "./StoreConfigPriceDefault";
import ActiveInActiveFilter from "./ActiveInActiveFilter";

const StoreConfigPrice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [priceListDataAll, setPriceListDataAll] = useState([]);
  const [priceListData, setPriceListData] = useState([]);
  const [storePriceAddModalVisible, setStorePriceAddModalVisible] =
    useState(false);

  const [activePriceItemId, setActivePriceItemId] = useState(null);
  const [activeInActiveFilterVisible, setActiveInActiveFilterVisible] =
    useState(false);

  const [brandPriceCodeValue, setBrandPriceCodeValue] = useState(null);
  const [selectedStorePriceValue, setSelectedStorePriceValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const { brandProfileData, userProfileRole } = getUserData();
  let brandId = brandProfileData.id;
  let userRole = userProfileRole;

  const fetchPriceCode = () => {
    getBrandPriceCode(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setSelectedStorePriceValue(res.prices);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchBrandStorePrice = () => {
    setLoading(true);
    getBrandStorePrice(brandId, id)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setPriceListDataAll(res);
          const NewRes = res.filter((item) => item.status === true);
          setPriceListData(NewRes);
          const defaultPriceList = res?.filter((item, index) =>
            item.default === true ? item?.id : null,
          );

          setActivePriceItemId(defaultPriceList[0]?.id);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchPriceCode();
    fetchBrandStorePrice();
  }, []);

  const receiveDataFromActiveInActiveFilter = (selectedValue) => {
    const newMap = priceListDataAll?.filter((service) =>
      selectedValue?.some((item) => item.value === service?.status),
    );
    setPriceListData(newMap);
  };

  const receiveDataFromBrandStorePriceStatusChange = ({ success }) => {
    if (success) {
      fetchPriceCode();
      fetchBrandStorePrice();
    }
  };

  const renderStorePriceCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div key={item.id}>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Price Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.price.priceCode}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status === true ? "Active" : "Inactive"}{" "}
                    </p>
                  </div>
                  {item.status && StoreData.enabledMultiPriceList && (
                    <div>
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Default
                      </p>
                      {/* {activePriceItemId && ( */}
                        <StoreConfigPriceDefault
                          // status={true === item.default}
                          activePriceStatus={activePriceItemId === item.id} // Check if this item is active
                          setActivePriceStatus={setActivePriceItemId}
                          sendDataToStoreConfig={
                            receiveDataFromBrandStorePriceStatusChange
                          }
                          editData={item}
                          brandId={brandId}
                          storeId={id}
                        />
                      {/* )} */}
                    </div>
                  )}
                  {userRole === "BY_FRANCHISE_ADMIN" ? (
                    ""
                  ) : (
                    <StorePriceStatusChange
                      status={item.status}
                      sendDataToStoreConfig={
                        receiveDataFromBrandStorePriceStatusChange
                      }
                      editData={item}
                      brandId={brandId}
                      storeId={id}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Price
              </p>
            </div>
          </div>
          <div
            onClick={() => setActiveInActiveFilterVisible(true)}
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          >
            <div>
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                style={{ width: 27 }}
              />
            </div>
          </div>
          {userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => {
                setStorePriceAddModalVisible(true);
                setBrandPriceCodeValue(selectedStorePriceValue);
              }}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : priceListData?.length > 0 ? (
          <div>
            <div>{renderStorePriceCardItem(priceListData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Price Data Present</p>
          </div>
        )}
      </div>
      <StorePriceAddModal
        storePriceAddModalVisible={storePriceAddModalVisible}
        setStorePriceAddModalVisible={setStorePriceAddModalVisible}
        sendDataToStoreConfig={receiveDataFromBrandStorePriceStatusChange}
        brandId={brandId}
        brandPriceCodeValue={brandPriceCodeValue}
        storeId={id}
        priceListData={priceListData}
      />
      <ActiveInActiveFilter
        setActiveInActiveFilterVisible={setActiveInActiveFilterVisible}
        activeInActiveFilterVisible={activeInActiveFilterVisible}
        sendDataToActiveInActiveFilter={receiveDataFromActiveInActiveFilter}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreConfigPrice;
